import { DocumentType, PaymentType } from '@innedit/innedit-type';
import React, { FC, SyntheticEvent, useState } from 'react';
import { toast } from 'react-toastify';

import IconLoading from '~/icons/Loading';

import Button from '../../../../components/Button';

interface ItemRequiresCaptureProps {
  payment: DocumentType<PaymentType>;
}
const ItemRequiresCapture: FC<ItemRequiresCaptureProps> = ({ payment }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [amount, setAmount] = useState<number>(0);
  const [selectedItems, setSelectedItems] = useState<boolean[]>(
    payment.items ? payment.items.map(() => false) : [],
  );

  const handleOnChangeItem = (event: SyntheticEvent<HTMLInputElement>) => {
    if (undefined !== event.currentTarget.getAttribute('data-index')) {
      const index = parseInt(
        event.currentTarget.getAttribute('data-index') as string,
        10,
      );
      const newSelectedItems = [...selectedItems];
      newSelectedItems[index] = !newSelectedItems[index];

      setAmount(
        newSelectedItems.reduce((acc, currentValue, currentIndex) => {
          let a = 0;

          if (payment.items) {
            a =
              payment.items[currentIndex].quantity *
              payment.items[currentIndex].price;
          }

          return acc + (currentValue ? a : 0);
        }, 0),
      );
      setSelectedItems(newSelectedItems);
    }
  };

  const handleCaptureOnSubmit = (event: SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsLoading(true);

    const indexes = selectedItems
      .reduce((acc, value, index) => {
        if (value) {
          acc.push(index);
        }

        return acc;
      }, [] as number[])
      .join(',');
    let url = `espaces/${payment.espaceId}/payment_intents/capture`;
    url += `?paiement=${payment.id}&amount=${amount}&items=${indexes}`;

    fetch(`${process.env.GATSBY_INNEDIT_PAYMENTS_URL}/${url}`)
      .then(r => r.json())
      .then(() => setIsLoading(false))
      .catch(error => {
        toast.error(error.message);
        setIsLoading(false);
      });
  };

  const handleCancelOnSubmit = (event: SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const url = `espaces/${payment.espaceId}/payment_intents/cancel?paiement=${payment.id}`;

    fetch(`${process.env.GATSBY_INNEDIT_PAYMENTS_URL}/${url}`)
      .then(r => r.json())
      .catch(toast.error);
  };

  return (
    <div className="mt-6">
      {payment.items?.map((item, index) => (
        <div key={item.id} className="flex items-center space-x-3">
          <input
            checked={selectedItems[index]}
            data-index={index}
            onChange={handleOnChangeItem}
            type="checkbox"
          />
          {item.thumbnail && (
            <img alt={item.label} src={item.thumbnail} width={30} />
          )}
          <span className="flex-1 overflow-hidden truncate text-ellipsis">
            {item.label}
          </span>
          <div>
            <span>{item.quantity}</span>
            {/* <input */}
            {/*  className="w-[50px] rounded-[0.25rem] border border-primary-300 bg-neutral-50 text-right outline-none focus:border-primary-400 focus:bg-light-400" */}
            {/*  type="number" */}
            {/*  value={item.quantity} */}
            {/* /> */}
            <span className="mx-1">x</span>
            <span>{item.price} €</span>
            {/* <input */}
            {/*  className="w-[60px] rounded-[0.25rem] border border-primary-300 bg-neutral-50 text-right outline-none focus:border-primary-400 focus:bg-light-400" */}
            {/*  type="number" */}
            {/*  value={item.price} */}
            {/* /> */}
            <span className="mx-1">=</span>
            <span className="w-[50px] whitespace-nowrap text-right">
              {item.quantity * item.price} €
            </span>
          </div>
        </div>
      ))}
      <div className="mt-6 flex">
        {amount > 0 ? (
          <Button
            className="flex-1"
            color="neutral"
            iconRight={isLoading ? IconLoading : undefined}
            onClick={handleCaptureOnSubmit}
            text={`Capturer ${amount} €`}
            variant="groove"
          />
        ) : (
          <Button
            className="flex-1"
            color="danger"
            onClick={handleCancelOnSubmit}
            text="Annuler le paiement"
            variant="groove"
          />
        )}
      </div>
    </div>
  );
};

export default ItemRequiresCapture;
